import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { CheckIcon, DownloadIcon, ExternalLinkIcon } from '../components/Icons';

interface LocationState {
  receiptNumber?: string;
  amount?: number;
  programTitle?: string;
  organisationName?: string;
}

const SuccessPage: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState;

  // Format currency
  const formatCurrency = (amount: number): string => {
    return `£${amount.toFixed(2)}`;
  };

  return (
    <div className="success-page">
      <Helmet>
        <title>Thank You! | Giving For The Living</title>
        <meta name="description" content="Thank you for your generous donation to Giving For The Living." />
      </Helmet>

      <div className="success-card">
        <div className="success-icon">
          <CheckIcon />
        </div>
        
        <h1 className="success-title">Thank You!</h1>
        <p className="success-message">
          Your donation has been received. You're making a real difference.
        </p>
        
        {state && (
          <div className="success-details">
            {state.programTitle && (
              <div className="success-details__row">
                <span className="success-details__label">Program</span>
                <span className="success-details__value">{state.programTitle}</span>
              </div>
            )}
            {state.organisationName && (
              <div className="success-details__row">
                <span className="success-details__label">Organisation</span>
                <span className="success-details__value">{state.organisationName}</span>
              </div>
            )}
            {state.amount && (
              <div className="success-details__row">
                <span className="success-details__label">Amount</span>
                <span className="success-details__value">{formatCurrency(state.amount)}</span>
              </div>
            )}
            {state.receiptNumber && (
              <div className="success-details__row">
                <span className="success-details__label">Receipt #</span>
                <span className="success-details__value">{state.receiptNumber}</span>
              </div>
            )}
          </div>
        )}
        
        <p style={{ fontSize: '0.875rem', color: '#6C757D', marginBottom: '1.5rem' }}>
          A confirmation email has been sent to your email address.
        </p>
        
        <div className="success-actions">
          <a 
            href="https://linkly.link/2RJRB" 
            className="success-button success-button--primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadIcon />
            Download Our App
          </a>
          
          <a 
            href="https://givingfortheliving.com" 
            className="success-button success-button--secondary"
          >
            <ExternalLinkIcon />
            Visit Giving For The Living
          </a>
        </div>
        
        <div style={{ marginTop: '2rem', padding: '1rem', backgroundColor: '#F8F9FA', borderRadius: '8px' }}>
          <p style={{ fontSize: '0.875rem', color: '#343A40', marginBottom: '0.5rem', fontWeight: '600' }}>
            Get the full experience!
          </p>
          <p style={{ fontSize: '0.8125rem', color: '#6C757D', marginBottom: '0' }}>
            Track your donations, see your impact, and discover new causes with the Giving For The Living app.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
